import { z } from 'zod';
import { vehiculeSchema } from '../vehicule/vehicule.schema';
import { vehiculeCheckEmailSchema } from '../vehicule-check-email/vehicule-check-email.schema';
import { EMAIL_REGEX, PHONE_REGEX } from '@/utils/regex.utils';
import { vehiculeCheckClientSchema } from '../vehicule-check-client.schema';
import i18next from 'i18next';
// import { ActionUserType } from '@/api/entities/vehicule-check';
// import dayjs from 'dayjs';

export const vehiculeCheckSchema = z
  .object({
    id: z.string().optional(),
    shortId: z.string().nullish(),
    groupId: z.string().nullish(),
    companyId: z.string().nullish(),
    branchId: z.string().nullish(),
    vehiculeId: z.string().nullish(),
    referenceNumber: z.string().nullish(),
    vehiculeCheckTypeId: z.string().nullish(),
    actionUserType: z.string().nullish(),
    actionUserId: z.string().nullish(),
    individualLastname: z.string().nullish(),
    individualFirstname: z.string().nullish(),
    individualEmail: z.string().nullish(),
    additionalEmails: z.union([z.string(), z.array(z.string())]).nullish(),
    individualPhone: z.string().nullish(),
    individualAddressLine1: z.string().nullish(),
    individualAddressLine2: z.string().nullish(),
    individualPostalCode: z.string().nullish(),
    individualCity: z.string().nullish(),
    individualCountry: z.string().nullish(),
    client: vehiculeCheckClientSchema.nullish(),
    startDate: z.any().nullish(),
    // endDate: z
    //   .any()
    //   .refine((value) => dayjs.isDayjs(value))
    //   .nullish(),
    endDate: z.any().nullish(),
    humanModerationStatus: z.string().nullish(),
    progressStatus: z.string().nullish(),
    vehicule: vehiculeSchema.nullish(),
    emailIsToSend: z.boolean().default(false),
    updateRequest: z.boolean().nullish(),
    emails: z.array(vehiculeCheckEmailSchema).nullish(),
    createdAt: z.any().nullish(),
  })
  .superRefine((data, ctx) => {
    // if (
    //   data.actionUserType === ActionUserType.INDIVIDUAL &&
    //   !data.referenceNumber
    // ) {
    //   ctx.addIssue({
    //     code: z.ZodIssueCode.custom,
    //     path: ['referenceNumber'],
    //     message: i18next.t('inspection:referenceNumberRequired'),
    //   });
    // }

    // if (!data.endDate) {
    //   ctx.addIssue({
    //     code: z.ZodIssueCode.custom,
    //     path: ['endDate'],
    //     message: i18next.t('inspection:inspectionEndDateRequired'),
    //   });
    // }

    // if (!data.vehicule?.licensePlateNumber) {
    //   ctx.addIssue({
    //     code: z.ZodIssueCode.custom,
    //     path: ['vehicule', 'licensePlateNumber'],
    //     message: i18next.t('common:licensePlateNumberRequired'),
    //   });
    // }

    if (data.individualEmail && !EMAIL_REGEX.test(data.individualEmail)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['individualEmail'],
        message: i18next.t('common:emailFormatIncorrect'),
      });
    }

    if (data.individualPhone && !PHONE_REGEX.test(data.individualPhone)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['individualPhone'],
        message: i18next.t('common:phoneNumberIncorrect'),
      });
    }
  });

export type TVehiculeCheckSchema = z.infer<typeof vehiculeCheckSchema>;
